// Sections
export const SECTION_CAPTIONED_CAROUSEL = 'FOUNDATION_SECTION_CAPTIONED_CAROUSEL';
export const SECTION_CAROUSEL = 'FOUNDATION_SECTION_CAROUSEL';
export const SECTION_FEATURES = 'FOUNDATION_SECTION_FEATURES';
export const SECTION_HTML = 'FOUNDATION_SECTION_HTML';
export const SECTION_IMAGE = 'FOUNDATION_SECTION_IMAGE';
export const SECTION_LEVELS = 'FOUNDATION_SECTION_LEVELS';
export const SECTION_OVERVIEW = 'FOUNDATION_SECTION_OVERVIEW';
export const SECTION_PROGRAM = 'FOUNDATION_SECTION_PROGRAM';
export const SECTION_QUOTES = 'FOUNDATION_SECTION_QUOTES';
export const SECTION_SHORTFORM = 'FOUNDATION_SECTION_SHORTFORM';
export const SECTION_SKILLS = 'FOUNDATION_SECTION_SKILLS';
export const SECTION_TABS = 'FOUNDATION_SECTION_TABS';
export const SECTION_VIDEO_CAROUSEL = 'FOUNDATION_SECTION_VIDEO_CAROUSEL';

// Components
export const COMPONENT_CAROUSEL_ITEM = 'FOUNDATION_COMPONENT_CAROUSEL_ITEM';
export const COMPONENT_FEATURE = 'FOUNDATION_COMPONENT_FEATURE';
export const COMPONENT_HTML = 'FOUNDATION_COMPONENT_HTML';
export const COMPONENT_IMAGE = 'FOUNDATION_COMPONENT_IMAGE';
export const COMPONENT_QUOTE = 'FOUNDATION_COMPONENT_QUOTE';
export const COMPONENT_TAB = 'FOUNDATION_COMPONENT_TAB';
export const COMPONENT_VIDEO = 'FOUNDATION_COMPONENT_VIDEO';

// Layout Width Options
export const WIDTH_CONSTRAINED = 'CONSTRAINED';
export const WIDTH_FULL = 'FULL';

// Layout Spacing Options
export const SPACE_NONE = 'NONE';
export const SPACE_DEFAULT = 'DEFAULT';
export const SPACE_SMALL = 'SMALL';
export const SPACE_MEDIUM = 'MEDIUM';
export const SPACE_LARGE = 'LARGE';

// Layout Type Options
export const TYPE_COLUMN_1 = 'COLUMN_1';
export const TYPE_COLUMN_2 = 'COLUMN_2';
export const TYPE_COLUMN_3 = 'COLUMN_3';
export const TYPE_COLUMN_4 = 'COLUMN_4';

// Column size Options
export const COLUMN_STYLE_PREFIX = 'col-md-';
export const COLUMN_PREFIX = 'COLUMN_';
